export default __webpack_public_path__ + "static/media/Liz_Kane_Resume.eecf3116.pdf";